import { createContext } from "react";

import { CascadiaModalTriggerOptions } from "./types";

export const ModalTriggerContext = createContext<CascadiaModalTriggerOptions>({
  isOpen: true,
  setIsOpen: () => {
    console.warn("Modal toggle attempted, but modal was not in a ModalTrigger");
  },
  toggle: () => {
    console.warn("Modal toggle attempted, but modal was not in a ModalTrigger");
  },
});
